<div class="input-group row gx-0">
  <input class="col-4 form-control" [(ngModel)]="amount" (ngModelChange)="onAmountInput($event)"
         [required]="required" step="1" type="number" [readonly]="readonly">
  <app-select class="col" [options]="units" [(ngModel)]="unit" (ngModelChange)="onUnitChange($event)"
              [required]="required" cssClass="rounded-0 rounded-end" [disabled]="readonly"></app-select>
</div>
